import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../utils/cn";
import { FOLDER_COLOR_STYLES, DEFAULT_FOLDER_COLOR } from "./folderColors";

// Chip de etiqueta: misma paleta que carpetas (el contrato) aplicada al PUNTO.
// The chip itself is a quiet neutral surface without a border (second visual
// pass): outlined pills next to each other read as a wall of boxes. With every
// chip tinted, a row read as a rainbow, so the hue lives only in the dot. El
// color nunca va solo: el nombre siempre se muestra, el punto es refuerzo.
export function labelColorStyles(color) {
  return FOLDER_COLOR_STYLES[color] || FOLDER_COLOR_STYLES[DEFAULT_FOLDER_COLOR];
}

export default function LabelChip({ label, className }) {
  const { t } = useTranslation();
  if (!label) return null;
  const styles = labelColorStyles(label.color);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-[5px] h-[20px] px-[8px] rounded-full bg-bg-subtle text-fg text-[11px] font-medium min-w-0 max-w-[160px] shrink-0",
        className,
      )}
      title={label.description || t("Etiqueta: {{nombre}}").replace("{{nombre}}", label.name)}
    >
      <span className={cn("w-1.5 h-1.5 rounded-full shrink-0", styles.dot)} aria-hidden="true" />
      <span className="truncate">{label.name}</span>
    </span>
  );
}
